import { useDispatch, useSelector } from 'react-redux';

import * as profileActions from '../actions';
import * as profileSelectors from '../selectors';

export default function useEditProfile() {
  const dispatch = useDispatch();
  const profile = useSelector(profileSelectors.getProfile);
  const errors = useSelector(profileSelectors.getErrors);

  const onFieldChanged = (fieldName, value) =>
    dispatch(profileActions.setFieldValue(fieldName, value));

  const onSave = () => dispatch(profileActions.save());
  const onSetProfile = (p) => dispatch(profileActions.setProfile(p));

  return { profile, errors, onSetProfile, onFieldChanged, onSave };
}
